<template>
  <v-container class="p-insure px-0">
    <v-layout row class="mt-2">
      <v-flex grow>
        <!-- 投保 -->
        <CSection title="保单" class="insure-card">
          <h3>订单号：{{policy.orderCode}}</h3>
          <v-form ref="form" lazy-validation class="form">
            <!-- 投保信息 -->
            <section class="form-section">
            <p class="mb-4">保全申请</p>
              <div class="form-item">
                <label>保全类型选择</label>
                <v-radio-group class="form-radio" :disabled="dateSync" row v-model="form.modifyFlag">
                  <v-radio label="人员新增" value="1"></v-radio>
                  <v-radio label="人员减少" value="2"></v-radio>
                  <v-radio label="人员替换" value="3"></v-radio>
                </v-radio-group>
              </div>
              <v-flex class="form-item" style="margin-bottom:20px">
                <label>下载模板</label>
                <div style="margin-top:6px">
                  <a v-if="form.modifyFlag == 2" class="notice-p primary-text" target="blank" href="https://qihuibao-group.oss-cn-beijing.aliyuncs.com/template/chac/%E4%BA%92%E8%81%94%E7%BD%91%E5%9B%A2%E4%BD%93%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BF%9D%E9%99%A9-%E5%87%8F%E5%91%98excel%E6%A8%A1%E6%9D%BF.xlsx">《互联网团体意外伤害保险减员excel模板》</a>
                  <a v-if="form.modifyFlag == 3" class="notice-p primary-text" target="blank" href="https://qihuibao-group.oss-cn-beijing.aliyuncs.com/template/chac/%E4%BA%92%E8%81%94%E7%BD%91%E5%9B%A2%E4%BD%93%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BF%9D%E9%99%A9-%E6%9B%BF%E6%8D%A2excel%E6%A8%A1%E6%9D%BF.xlsx">《互联网团体意外伤害保险替换excel模板》</a>
                  <a v-if="form.modifyFlag == 1" class="notice-p primary-text" target="blank" href="https://qihuibao-group.oss-cn-beijing.aliyuncs.com/template/chac/%E4%BA%92%E8%81%94%E7%BD%91%E5%9B%A2%E4%BD%93%E6%84%8F%E5%A4%96%E4%BC%A4%E5%AE%B3%E4%BF%9D%E9%99%A9%E5%A2%9E%E5%91%98excel%E6%A8%A1%E6%9D%BF.xlsx">《互联网团体意外伤害保险增员excel模板》</a>
                  <a class="notice-p primary-text" target="blank" href="https://qihuibao-group.oss-cn-beijing.aliyuncs.com/template/chac/9_%E5%92%8C%E9%A1%BA%E4%BF%9D%E4%BA%92%E8%81%94%E7%BD%91%E5%9B%A2%E6%84%8F_%E8%81%8C%E4%B8%9A%E7%B1%BB%E5%88%AB%E8%A1%A8_1-6%E7%B1%BB%E8%81%8C%E4%B8%9A%20%EF%BC%88%E4%BA%92%E8%81%94%E7%BD%91%E5%9B%A2%E6%84%8F%E4%B8%93%E5%B1%9E%EF%BC%89.xlsx">《职业分类表》</a>
                </div>
              </v-flex>
              <v-layout>
                <v-flex class="form-item form-time">
                    <label>保全提交日期</label>
                    <p class="time">{{today}}</p>
                </v-flex>

                  <v-flex class="form-item ">
                    <label>保全生效日期</label>
                    <!-- 只能选择明天-明天30天以内的时间 -->
                    <v-menu
                      ref="dateMenu"
                      v-model="effectBeginDateMenuVisible"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      lazy
                      :disabled="dateSync"
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        class="date-input"
                        v-model="form.effectDate"
                        :disabled="dateSync"
                        :solo="solo"
                        :rules="rules.effectDate"
                        append-icon="calendar_today"
                        readonly
                      ></v-text-field>
                      <v-date-picker
                        v-model="form.effectDate"
                        :header-date-format="date=>date"
                        :min="minEffectBeginDate"
                        :max="maxEffectBeginDate"
                        no-title
                        @input="effectBeginDateMenuVisible = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
              </v-layout>
                <v-flex class="form-item">
                <label>上传保全清单</label>
                <CUpload
                  :show="false"
                  :on-success="onUploadSuccess"
                  :upLoadSync="upSync"
                  @isClickUp="isUp"
                  :on-error="onUploadError"
                  :limit="1"
                  accept=".xlsx, .xls"
                >上传文件</CUpload>
                <!-- <v-btn color="primary" @click="checkList" :disabled="!dateSync">保全清单查看</v-btn> -->
              </v-flex>
              <v-flex class="form-item">
                <label>投保人邮箱</label>
                <p  style="margin-top:7px">{{policy.applicantEmail}}</p>
              </v-flex>
               <v-flex class="form-item">
                <label>投保人名称</label>
                <p style="margin-top:7px">{{policy.applicantName}}</p>
              </v-flex>
              <div>
                <label>承保方案</label>
                <InsurancePlanTable
                  v-model="form.amount"
                  :employees="employees"
                  :code="2016"
                  :allRes="planAllList"
                  :plan-id="form.productPlanId"
                  :effect-duration="form.effectDuration"
                  :orderList.sync="policy"
                ></InsurancePlanTable>
              </div>
              <template v-if="form.modifyFlag == 2&&policy.payType==1">
                <p class="introduce-text invoice-status">*提示：退款至投保公司的收款账户，请填写收款账户信息</p>
                <v-flex class="form-item" style="margin-left: 0">
                  <label class="form-label-left">公司名称</label>
                  <p style="height: 50px;line-height: 37px">{{policy.applicantName}}</p>
                </v-flex>
                <v-flex class="form-item form-item-bank" style="width: 725px">
                  <label class="form-label-left"><span class="must-tap">*</span>开户行名称</label>
                  <v-text-field
                    v-model="form.bankName"
                    :solo="solo"
                    :rules="rules.bankName"
                    label
                  ></v-text-field>
                  <label class="invoice-status"><span class="must-tap">*提示：请填写详细开户行信息</span></label>
                </v-flex>
                <v-flex class="form-item form-item-bank">
                  <label class="form-label-left"><span class="must-tap">*</span>开户行账号</label>
                  <v-text-field
                    v-model="form.bankNo"
                    :solo="solo"
                    :rules="[rules.bankNoRequired]"
                    label
                    :error-messages="backNoCheck"
                    @blur="checkBack"
                  ></v-text-field>
                </v-flex>
              </template>
              <v-layout class="price-footer" v-if="totalCount!=0">
                  <div class="people">人数汇总：{{totalCount}}</div>
                  <div class="price">总保费：{{totalMoney}}</div>
              </v-layout>
              <aig-birthday-table
                      v-if="birthdayWarningCount > 0"
                      :data="birthdayWarningData"
                      :code="2016"
              />
                <v-btn v-if="!backbtn" color="primary" :loading="subloading" @click="submit" :disabled="employeeUrl===''">提交</v-btn>
                <v-btn v-if="backbtn&&form.modifyFlag != 1" color="primary" @click="backList">返回</v-btn>
<!--                <v-btn v-if="payUrl&&form.modifyFlag == 1&&policy.payType!=1" color="primary" @click="gopay">线上支付-->
<!--                </v-btn>-->
<!--                <v-btn v-if="payUrl&&form.modifyFlag == 1&&policy.payType==1" color="primary" @click="downpay">线下支付</v-btn>-->
              <v-btn v-if="form.modifyFlag == 1&&goPayBtn == true" :loading="subloading" color="primary" @click="goNewPay">去支付</v-btn>
              <div v-if="endorsementCode!=''&&form.modifyFlag ==2">
                <p class="introduce-text attention">【专票红冲规则】1.没有抵扣，寄回发票原件。2.已经抵扣，寄回信息表。邮费客户承担。退费金额超过人民币1万元的，填写《客户信息登记表》，请注意查收邮件并下载附件《客户信息登记表》，美亚后援中心接收到退保材料后，材料齐全，5个工作日付款。退款退回原账户。</p>
                <h3 class="mt-4 mb-3" style="color:#999">邮寄地址</h3>
                    <v-layout class="group-info">

                      <v-flex>
                        <p class="introduce-text"><span class="info-pay">收件人姓名</span>：BJ CPS</p>
                        <p class="introduce-text"><span class="info-pay">联系电话</span>：010-59692888</p>
                        <p class="introduce-text"><span class="info-pay">地址</span>：北京市朝阳区建国路79 号华贸中心2 号写字楼10 层05，06号 </p>
                        <p class="introduce-text"><span class="info-pay">客服电话</span>：4006-234-345</p>
                      </v-flex>
                    </v-layout>
              </div>
            </section>
          </v-form>
        </CSection>
      </v-flex>
    </v-layout>
    <CompanyAccountDetail
            :companyName="policy.applicantName"
            :orderCode="endorsementCode"
            v-model="isCompanyPay"
            :policySaveObj="policySaveObj"
            policyType="endorsement"
            @submitCompany="submitCompany" />
  </v-container>
</template>

<script>
import InsurancePlanTable from "@/components/Order/applyTable";
import areaList from '@/assets/js/area';
import CompanyAccountDetail from "../../insure/components/CompanyAccountDetail";
import aigBirthdayTable from "@/components/Order/aigBirthdayTable";

export default {
  components: {
    InsurancePlanTable,
    CompanyAccountDetail,
    aigBirthdayTable
  },
  props: {
    policy: Object,
  },
  data() {
    return {
      subloading:false,
      today:'',
      backbtn:false,
      upSync:false,
      insuredList:[],
      employeeUrl:'',
      dateSync:false,
      endorsementCode:'',
      payUrl:'',
      totalMoney:0,
      totalCount:0,
      planAllList:{},
      downloading:false,
      areaList:areaList,
      solo: true,
      formValid: true,
      form: {
        // 生效日期
        effectDate: "",
        // 保障期限
        effectDuration: 12,
        // 产品方案，现在只有方案D了
        productPlanId: 4,
        modifyFlag: '1',
        amount: 0,
        email:''
      },
      rules: {
        effectDate: [v => !!v || "请选择生效日期"],
        email: [v => !!v || "请输入邮箱"],
        bankNoRequired: value => !!value || '请输入开户行号',
        bankName: [v => !!v || "请输入开户行名称"]
      },
      // 生效日期选择菜单是否可见
      effectBeginDateMenuVisible: false,
      // 最小生效日期 T+3
      minEffectBeginDate: "",
      maxEffectBeginDate:"",
      employees: [],
      //保障方案列表,由 Plan 组件实时传递
      loading: false,
      backNoCheck: "",
      goPayBtn:false,
      //支付前确认信息
      isCompanyPay:false,
      policySaveObj:{},
      //是否有大于65周岁的数据
      birthdayWarningCount: 0,
      birthdayWarningData: []
    };
  },
  computed: {
    user() {
      return this.$store.state.user.userInfo;
    }
  },
  watch:{
    // 'form.modifyFlag'(val){
    //   if(val == 2){
    //     this.minEffectBeginDate = this.policy.insureStartDate;
    //     this.form.effectDate = this.$miment(this.minEffectBeginDate)
    //       .add(1, "DD")
    //       .format("YYYY-MM-DD");
    //   }else if(val == 1){
    //     this.minEffectBeginDate = this.$miment()
    //       .add(1, "DD")
    //       .format("YYYY-MM-DD");
    //     this.form.effectDate = this.minEffectBeginDate;
    //   }
    // }
    'form.modifyFlag'(val){
      if (val == 2){
        this.form.bankNo = "";
        this.form.bankName = "";
      }
    }
  },
  created() {
    this.$store.dispatch("getUserInfo");
    this.form.effectDuration = this.policy.insurancePeriodUnit == 3?12:this.policy.insurancePeriod
    this.employees = this.policy.policyDetailList
    this.employees.forEach(ele => {
      delete ele.applicantCount
    });
    this.today = this.$miment().format("YYYY-MM-DD");
    let tomorrow = this.$miment().add(1, "DD")
    this.planAllList = this.policy
    this.items = this.policy.insuredList
    this.minEffectBeginDate= this.$miment(this.policy.insureStartDate)>=tomorrow?this.policy.insureStartDate:tomorrow.format("YYYY-MM-DD")
    this.form.effectDate = this.minEffectBeginDate;
    this.maxEffectBeginDate = this.$miment(this.minEffectBeginDate).add(59, "DD").format("YYYY-MM-DD");
  },
  methods: {
    checkList(){

    },
    backList(){
      this.$router.push('/orderInsure')
    },
    onUploadSuccess(file) {
      let formData = new FormData();
      formData.append("policyId", this.policy.id);
      formData.append("effectDate", this.form.effectDate);
      formData.append("modifyFlag", this.form.modifyFlag);
      formData.append("file", file);
      this.$axios.post('/app/api/heshunbao/uploadEndorsementEmployee',formData).then(res=>{
        if(res.code == 200){
          this.$message.success('上传成功')
        }
        this.employees = this.mapArr([...this.employees,...res.data.showPlanList])
        this.insuredList = res.data.insuredList
        this.employeeUrl = res.data.employeeUrl
        this.dateSync = true;
        this.upSync = false;
        this.waringData(res.data);
      }).catch((val)=>{
        this.$message.error(val.message)
        this.dateSync = false;
        this.upSync = false
      })

    },
    checkBack() {
      this.backNoCheck = "";
      if (this.form.bankNo) {
        this.$axios.get('https://ccdcapi.alipay.com/validateAndCacheCardInfo.json?cardNo='+this.form.bankNo+"&cardBinCheck=true").then(res => {
          if(!res.validated){
            this.backNoCheck = "请输入正确的开户行号"
          }
        })
      }
    },
    submit(){
      if (this.$refs.form.validate()) {
        this.subloading = true
        const data = {
          insuredList: this.insuredList,
          employeeUrl: this.employeeUrl,
          policyId: this.policy.id,
          effectDate: this.$miment(this.form.effectDate).format("YYYY-MM-DD hh:mm:ss"),
          modifyFlag: this.form.modifyFlag
        }
        if (this.form.modifyFlag == 2){
          data.bankNo = this.form.bankNo;
          data.bankName = this.form.bankName;
        }
        this.$axios.post('/app/api/heshunbao/submitEndorsement', data).then(res => {
          this.totalMoney = res.data.totalPrice;
          this.backbtn = true
          this.totalCount = res.data.count;
          this.employees = this.mapArr([...this.employees, ...res.data.showPlanJobList])
          this.endorsementCode = res.data.endorsementCode
          this.payUrl = res.data.payUrl;
          this.upSync = false;
          this.goPayBtn = true;
          this.policySaveObj = res;
        }).catch((val) => {
          this.$message.error(val.message)
          this.subloading = false
          this.upSync = false
        }).finally(()=>{
          this.subloading = false
        })
      }
    },
    mapArr(arr){
      let deWeightThree = () => {
          let map = new Map();
          for (let item of arr) {
            if (map.has(item.jobName)) {
              map.delete(item.jobName);
            }
            if (!map.has(item.jobName)) {
              map.set(item.jobName, item);
            }
          }
          return [...map.values()];
      }
      return deWeightThree();
    },
    gopay(){
      window.location.href = this.payUrl
    },
    downpay(){
      this.$router.push({
        path:'/insure/downPay',
        query:{
          param:window.btoa(JSON.stringify({orderCode:this.endorsementCode,amount:this.totalMoney,from:'bq'}))
        }
      })
    },
    //新的去支付
    goNewPay(){
      this.subloading = true;
      if (this.policy.payType == 1){
        this.downpay();
      }else{
        this.isCompanyPay = true;
      }
    },
    submitCompany(){
      this.$axios.get('/app/api/heshunbao/getEndorsementPayUrl?endorsementCode='+this.endorsementCode).then(res => {
        this.subloading = false
        this.payUrl = res.data;
        this.gopay();
      })
    },
    isUp(val){
      if(val){
        this.upSync = true
      }
    },
    onUploadError(err) {
      // this.$message.error(err.message);
      this.upSync = false
      let error = err.message.replace(/;/g, "<br>");
      const message =
        "您导入的员工信息中有格式错误，请修改后重新上传，具体错误信息如下所示：<br>" +
        error;
      this.$messageBox.alert({
        message,
        width: 500
      });
    },
      downFile(){
        this.downloading = true
        const elink = document.createElement("a");
        elink.style.display = "none";
        elink.href = process.env.VUE_APP_API_URL+'/app/api/heshunbao/downloadEmployee?orderCode='+this.policy.orderCode;
        document.body.appendChild(elink);
        elink.click();
        document.body.removeChild(elink);
        this.$axios.get('/app/api/heshunbao/downloadEmployee?orderCode='+this.policy.orderCode).then(()=>{
            this.downloading = false
        }).catch(()=>{
            this.downloading = false
        })
      },
    waringData(res){
      if (res.warningCount > 0){
        this.birthdayWarningCount = res.warningCount;
        this.birthdayWarningData = res.warningBirthdayList.map( res => {
          return {
            name: res.name,
            idNumber: res.identifyNumber,
            professionName: res.jobName,
          }
        })
      }
    }
  }
};
</script>


<style lang="scss">
$form-item-left-width: 284px;
$form-item-label-width: 84px;
$label-margin-right: 20px;
$input-width: $form-item-left-width - $form-item-label-width -
  $label-margin-right;
$nopay-color: #fb7282;
.invoice-status,.must-tap{
  color: $primary-color;
}
  .form-time{
    width:0!important;
    margin-right: 0!important;
  }
  .form-radio{
    margin-top: -2px;
    label{
      margin-top: 0;
    }
  }
  .price-footer{
  margin-top: 30px;
  justify-content: right;
}
  .time{
    font-size: 14px;
    color: $primary-color;
    margin-top: 7px;
    margin-left: 7px;
  }
.p-insure {
  .insure-card {
    .form-section {
      padding: 30px 137px 12px 0;
    }
    .plan-section {
      padding: 40px 0;
      .form-item {
        width: 240px !important;
        .plan-section-label {
          width: 56px;
        }
      }
    }
    .form {
      .form-item-bank{
        width: 500px;
        margin-right: 0;
        label.invoice-status{
          width: 225px;
          margin-right: 0;
        }
      }
      .form-item {
        label {
          width: $form-item-label-width;
          text-align: right;
        }
        label.form-label-left{
          text-align: left;
        }
      }
      .form-item-left {
        width: $form-item-left-width;
        flex-grow: 0;
        .date-input {
          width: $input-width;
        }
      }
      .form-item-btn-mb {
        margin-bottom: 28px;
      }
      .form-item-btn-wrap {
        width: $input-width;
        .v-btn {
          margin: 0;
        }
      }
    }
  }
  .right-section {
    width: 330px;
    margin-left: 20px;
    .pay-card {
      margin: 0;
      width: 330px;
      padding: 50px 25px;
      font-size: 14px;
      .line {
        margin: 20px 0;
      }
      .checkbox {
        margin-top: -4px;
      }
      .pay-btn {
        margin-top: 30px;
        height: 50px;
      }
    }
  }
}
.group-info {
    &-item {
      width: 225px;
      height: 57px;
      border: 1px solid $explain-color;
      flex: none;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;
      cursor: pointer;
      &-img {
        width: 126px;
        height: 45px;
      }
      &-checked {
        position: absolute;
        right: 0;
        bottom: 0;
        width: 24px;
      }
    }
  }
  .info-pay{
    width: 90px;
    display: inline-block;
}
.attention{
    color: $primary-color;
    margin-top: 20px;
}
</style>
